import type { ContentTypeType } from '@confluence/editor-features/entry-points/ContentTypeType';

export const onClickPageRevert = (
	push: any,
	contentType: ContentTypeType | null,
	spaceKey: string,
	contentId?: string,
) => {
	if (contentType && contentId) {
		const isBlogPost = contentType === 'blogpost';
		const url = isBlogPost
			? `${window.location.origin}/wiki/spaces/${spaceKey}/blog/edit/${contentId}`
			: `${window.location.origin}/wiki/spaces/${spaceKey}/pages/edit/${contentId}`;

		push(url);
	}
};
